import PriceBadgeBlock from "./PriceBadgeBlock";

export * from "./PriceBadgeBlock";
export default PriceBadgeBlock;
